import React from 'react';
import { useState } from 'react';
import { FaUserCheck, FaUserTimes, FaSignOutAlt, FaPhoneAlt } from 'react-icons/fa';
import { motion } from 'framer-motion';
import Logo from "../assets/Logo"; 
import {useContext} from "react"; 
import {AuthContext} from "../AuthContext"; 
import {useNavigate} from "react-router-dom"; 
import WhatsAppSupportLink from "./WhatsAppSupportLink"; 
import Loading from "../pages/Loading"; 
const DashboardHeader = ({ userName, kycStatus, accountStatus, logOutUser }) => {
  const [isOpen, setIsOpen] = useState(false);
  const {logout} = useContext(AuthContext); 
  const navigate = useNavigate(); 
  const handleToggleMenu = () => {
    setIsOpen(!isOpen);
  };
  const handleLogout = ()=>{
	 logOutUser(); 
  }
  return (
    <header className="w-full bg-white shadow-lg fixed top-0 left-0 z-50">
      <motion.div
        className="container mx-auto px-4 py-4 flex justify-between items-center"
        initial={{ opacity: 0, y: -50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, ease: 'easeOut' }}
      >
        {/* Logo */}
        <div className=" text-lg md:text-xl font-bold flex items-center gap-3">
			 <Logo size = "60"/>
			 OfficialBillboard
		  </div>

        {/* Navigation Links */}
        <div className="hidden md:flex space-x-8 items-center">
          {/* KYC Status */}
          <motion.div
            className={`flex items-center p-2 rounded-lg bg-${
              kycStatus === 'Verified' ? 'green-500' : 'red-500'
            } text-white shadow-md`}
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            transition={{ duration: 0.4 }}
          >
            {kycStatus === 'Verified' ? <FaUserCheck className="mr-2" /> : <FaUserTimes className="mr-2" />}
            <p>{kycStatus}</p>
          </motion.div>

          {/* Account Status */}
          <motion.div
            className={`p-2 rounded-lg bg-${
              accountStatus === 'Active' ? 'blue-500' : 'yellow-500'
            } text-white shadow-md`}
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            transition={{ duration: 0.6 }}
          >
            <span>{accountStatus}</span>
          </motion.div>

          {/* Contact Us */}
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.8 }}
          >
				  <WhatsAppSupportLink supportMessage = "contact us" />
          </motion.div>

          {/* Logout */}
          <motion.div
            className="flex items-center p-2 bg-blue-500 text-white rounded-lg shadow-md cursor-pointer hover:bg-red-600"
            initial={{ x: 100 }}
            animate={{ x: 0 }}
            transition={{ duration: 0.7 }}
            onClick={handleLogout}
          >
            <FaSignOutAlt className="mr-2" />
            <p>Logout</p>
          </motion.div>
        </div>

        {/* Hamburger Menu for Mobile */}
        <div className="md:hidden">
          <button onClick={handleToggleMenu} className="text-2xl focus:outline-none">
            ☰
          </button>
        </div>
      </motion.div>

      {/* Mobile Menu */}
      {isOpen && (
        <motion.div
          className="md:hidden bg-gray-100 py-4 px-4 space-y-4 shadow-lg"
          initial={{ height: 0 }}
          animate={{ height: 'auto' }}
          transition={{ duration: 0.5, ease: 'easeOut' }}
        >
          <motion.div
            className={`flex items-center p-2 rounded-lg bg-${
              kycStatus === 'Verified' ? 'green-500' : 'red-500'
            } text-white shadow-md`}
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            transition={{ duration: 0.4 }}
          >
            {kycStatus === 'Verified' ? <FaUserCheck className="mr-2" /> : <FaUserTimes className="mr-2" />}
            <p>{kycStatus}</p>
          </motion.div>

          <motion.div
            className={`p-2 rounded-lg bg-${
              accountStatus === 'Active' ? 'blue-500' : 'yellow-500'
            } text-white shadow-md`}
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            transition={{ duration: 0.6 }}
          >
            <p>{accountStatus}</p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.8 }}
          >
				  <WhatsAppSupportLink supportMessage = "contact us"/>
          </motion.div>

          <motion.div
            className="flex items-center p-2 bg-blue-500 text-white rounded-lg shadow-md cursor-pointer hover:bg-red-600"
            initial={{ x: 100 }}
            animate={{ x: 0 }}
            transition={{ duration: 0.7 }}
            onClick={handleLogout}
          >
            <FaSignOutAlt className="mr-2" />
            <span>Logout</span>
          </motion.div>
        </motion.div>
      )}
    </header>
  );
};

export default DashboardHeader;

